export const heroData = {
  title: "日韩欧美风格一站式精选",
  subtitle: "潮流尽在此处",
  description: "探索日韩欧美最新潮流趋势，汇聚日韩欧美顶尖品牌与风格精华。无论你钟爱日系清新、韩系时尚还是欧美大气，这里一站满足，让你轻松驾驭多元国际风格，打造专属时尚态度。",
  ctaText: "探索潮流",
  ctaLink: "/category",
  secondaryText: "了解更多",
  secondaryLink: "/about",
};

export const trendingItems = [
  {
    id: "trend-1",
    name: "日系复古格纹西装外套",
    category: "日系",
    image: "https://readdy.ai/api/search-image?query=Japanese%20vintage%20plaid%20blazer%20in%20cream%20and%20beige%20tones%2C%20minimalist%20fashion%20photography%2C%20clean%20cream%20studio%20background%2C%20soft%20natural%20lighting%2C%20elegant%20editorial%20style%2C%20high%20fashion%20catalog%20aesthetic&width=600&height=750&seq=trend-1-2026&orientation=portrait",
  },
  {
    id: "trend-2",
    name: "韩系宽松廓形风衣",
    category: "韩系",
    image: "https://readdy.ai/api/search-image?query=Korean%20oversized%20trench%20coat%20in%20warm%20beige%2C%20clean%20minimalist%20fashion%20photography%2C%20cream%20studio%20backdrop%2C%20soft%20natural%20lighting%2C%20elegant%20editorial%20style%2C%20high%20fashion%20catalog&width=600&height=750&seq=trend-2-2026&orientation=portrait",
  },
  {
    id: "trend-3",
    name: "欧美简约真皮手袋",
    category: "欧美",
    image: "https://readdy.ai/api/search-image?query=European%20minimalist%20leather%20handbag%20in%20warm%20tan%20color%2C%20clean%20product%20photography%2C%20cream%20studio%20background%2C%20soft%20natural%20lighting%2C%20elegant%20editorial%20lifestyle%20aesthetic&width=600&height=750&seq=trend-3-2026&orientation=portrait",
  },
  {
    id: "trend-4",
    name: "日系层叠穿搭长裙",
    category: "日系",
    image: "https://readdy.ai/api/search-image?query=Japanese%20layered%20maxi%20dress%20in%20soft%20neutral%20tones%2C%20minimalist%20fashion%20photography%2C%20cream%20studio%20backdrop%2C%20soft%20natural%20lighting%2C%20elegant%20feminine%20editorial%20style&width=600&height=750&seq=trend-4-2026&orientation=portrait",
  },
  {
    id: "trend-5",
    name: "韩系街头运动套装",
    category: "韩系",
    image: "https://readdy.ai/api/search-image?query=Korean%20street%20style%20matching%20sportswear%20set%20in%20cream%20and%20grey%2C%20minimalist%20fashion%20photography%2C%20clean%20studio%20background%2C%20soft%20natural%20lighting%2C%20casual%20chic%20editorial%20aesthetic&width=600&height=750&seq=trend-5-2026&orientation=portrait",
  },
  {
    id: "trend-6",
    name: "欧美极简设计腕表",
    category: "欧美",
    image: "https://readdy.ai/api/search-image?query=European%20minimalist%20wristwatch%20with%20leather%20strap%2C%20clean%20product%20photography%2C%20cream%20studio%20background%2C%20soft%20natural%20lighting%2C%20luxury%20editorial%20aesthetic%2C%20warm%20tones&width=600&height=750&seq=trend-6-2026&orientation=portrait",
  },
];

export const categoryShowcase = [
  {
    id: "japanese",
    name: "日系风格",
    description: "清新自然、简约优雅的和风美学",
    image: "https://readdy.ai/api/search-image?query=Japanese%20minimalist%20fashion%20style%20with%20neutral%20tones%20and%20natural%20fabrics%2C%20clean%20aesthetic%20lifestyle%20photography%2C%20cream%20and%20beige%20color%20palette%2C%20soft%20natural%20lighting%2C%20zen%20inspired%20composition&width=800&height=500&seq=cat-jp-2026&orientation=landscape",
    link: "/category?type=japanese",
  },
  {
    id: "korean",
    name: "韩系风格",
    description: "时尚前卫、精致都市的潮流典范",
    image: "https://readdy.ai/api/search-image?query=Korean%20contemporary%20fashion%20style%20with%20clean%20lines%20and%20modern%20silhouettes%2C%20minimalist%20studio%20photography%2C%20cream%20and%20warm%20beige%20backdrop%2C%20soft%20natural%20lighting%2C%20editorial%20aesthetic&width=800&height=500&seq=cat-kr-2026&orientation=landscape",
    link: "/category?type=korean",
  },
  {
    id: "european",
    name: "欧美风格",
    description: "大气简约、经典质感的国际风尚",
    image: "https://readdy.ai/api/search-image?query=European%20classic%20fashion%20style%20with%20tailored%20pieces%20and%20luxurious%20fabrics%2C%20minimalist%20studio%20photography%2C%20cream%20and%20warm%20neutral%20backdrop%2C%20soft%20natural%20lighting%2C%20editorial%20aesthetic&width=800&height=500&seq=cat-eu-2026&orientation=landscape",
    link: "/category?type=european",
  },
];

export const latestArticles = [
  {
    id: "article-1",
    title: "2026秋冬日系穿搭指南：层次感是关键词",
    excerpt: "日系穿搭的精髓在于层次感的营造。从基础款到点睛配饰，我们为你解析本季最值得关注的日系潮流元素，让你轻松驾驭日系风格。",
    category: "日系",
    date: "2026-07-28",
    readTime: "8分钟",
    image: "https://readdy.ai/api/search-image?query=Japanese%20fall%20winter%20layered%20fashion%20outfit%20inspiration%2C%20neutral%20warm%20tones%2C%20minimalist%20studio%20photography%2C%20cream%20backdrop%2C%20soft%20natural%20lighting%2C%20editorial%20aesthetic&width=700&height=450&seq=article-1-2026&orientation=landscape",
  },
  {
    id: "article-2",
    title: "韩系偶像风穿搭秘诀：从舞台到日常",
    excerpt: "韩国偶像的穿搭一直是潮流风向标。本文拆解韩系偶像穿搭的精髓，教你把舞台造型转化为日常可穿的时尚搭配。",
    category: "韩系",
    date: "2026-07-22",
    readTime: "6分钟",
    image: "https://readdy.ai/api/search-image?query=Korean%20idol%20inspired%20casual%20fashion%20outfit%2C%20modern%20urban%20style%2C%20minimalist%20studio%20photography%2C%20cream%20backdrop%2C%20soft%20natural%20lighting%2C%20editorial%20aesthetic&width=700&height=450&seq=article-2-2026&orientation=landscape",
  },
  {
    id: "article-3",
    title: "欧美极简主义：少即是多的穿搭哲学",
    excerpt: "欧美极简风格正在重塑时尚界。从Capsule Wardrobe到高质量基础款，我们带你深入了解欧美极简穿搭的核心法则。",
    category: "欧美",
    date: "2026-07-18",
    readTime: "7分钟",
    image: "https://readdy.ai/api/search-image?query=European%20minimalist%20capsule%20wardrobe%20aesthetic%2C%20neutral%20beige%20and%20cream%20tones%2C%20clean%20studio%20photography%2C%20soft%20natural%20lighting%2C%20editorial%20lifestyle%20aesthetic&width=700&height=450&seq=article-3-2026&orientation=landscape",
  },
];